<template>
    <div class="categoryList" v-if="conformations != null">
      <category-contact-us
        v-for="(conformation , index) in conformations"
        :selectedConformations="selectedConformations"
        :key="conformation.num"
        :conformation="conformation"
        :index="index"
      />
    </div>
</template>

<script>
    import { mapGetters , mapState , mapActions , mapMutations } from 'vuex'
    import Category from "../Portfolio/Category";
    import CategoryContactUs from "./Category";

    export default {
        name: "category-list-contactus" ,
        components : {
          CategoryContactUs,
          Category

        },
        computed : {
          ...mapState('contactUsStore' ,
            [
              'conformations' ,
              'selectedConformations' ,
              'selectedSpecificity' ,
            ]
          )
        } ,
        watch : {
          selectedConformations () {

          },
        },
        created () {
          this.API__GET__CATEGORIES();
          //this.$store.dispatch('contactUsStore/API__GET__CATEGORIES');
        },
        mounted () {

        },
        data () {
          return {

          }
        },
        methods : {
          ...mapActions('contactUsStore' , ['API__GET__CATEGORIES']) ,
        }
    }
</script>

<style scoped lang="scss">
  .categoryList{
    display: flex;
    flex-flow : row wrap;
    width:100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/menu/ContactUs/CategoryList.vue